<!-- Generated template for the CalendarComponent component -->
<div class="calendar-wrapper">
    <div class="calendar-header">

        <div class="title">
            {{ monthsNames[month] | transloco }} {{ year }}
        </div>

        <div class="arrows">
            <div class="calendar-arrow-prev" (click)="prevMonth()">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M12.9067 4.19149C12.6447 3.96685 12.2501 3.9972 12.0255 4.25928L7.02545 10.0926C6.82483 10.3267 6.82483 10.672 7.02545 10.9061L12.0255 16.7394C12.2501 17.0015 12.6447 17.0319 12.9067 16.8072C13.1688 16.5826 13.1992 16.188 12.9745 15.926L8.32316 10.4994L12.9745 5.07277C13.1992 4.81069 13.1688 4.41613 12.9067 4.19149Z"
                          fill="#3F403F"/>
                </svg>

            </div>

            <div class="calendar-arrow-next" (click)="nextMonth()">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M7.09327 4.19149C7.35535 3.96685 7.74991 3.9972 7.97455 4.25928L12.9745 10.0926C13.1752 10.3267 13.1752 10.672 12.9745 10.9061L7.97455 16.7394C7.74991 17.0015 7.35535 17.0319 7.09327 16.8072C6.83119 16.5826 6.80084 16.188 7.02548 15.926L11.6768 10.4994L7.02548 5.07277C6.80084 4.81069 6.83119 4.41613 7.09327 4.19149Z"
                          fill="#3F403F"/>
                </svg>

            </div>
        </div>

    </div>
    <table>
        <thead>
        <tr>
            <td *ngFor="let index of dayIndex">
                <span>{{ dayShortNames[index] | transloco}}</span>
            </td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let week of dayRows,let j = index">
            <td *ngFor="let day of week, let i = index" [ngClass]="{'holiday-wrapper': day.holiday, 'absence-wrapper':day.absence}">
                  <span *ngIf="day.empty == true" class="empty-day">
                    &nbsp;
                  </span>
                <span *ngIf="day.empty == false" class="calendar-day
                        {{ day.color? 'border border'+day.color : '' }}
                        {{ day.holiday == true ? 'holiday' : '' }}
                        {{ day.absence ? 'absence' : '' }}"
                      (click)="selectDate(day)">
                           {{ day.day }}
                 </span>

                <div class="popup" *ngIf="day.holiday">

                    <div class="svg">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.30142 16C2.95077 16 2.6665 15.7157 2.6665 15.3651C2.6665 9.43765 6.72775 4.45878 12.2194 3.05927C12.0166 3.31609 11.8283 3.58704 11.654 3.86607C10.6729 5.4368 9.99099 7.47376 9.51212 9.42875C9.02959 11.3987 8.7361 13.3588 8.56311 14.8199C8.51079 15.2619 8.46932 15.6597 8.4369 16H3.30142Z"
                                fill="#83B25F"/>
                            <path
                                d="M29.3332 15.3651C29.3332 15.7157 29.0489 16 28.6982 16H23.5628C23.5304 15.6597 23.4889 15.2619 23.4366 14.8199C23.2636 13.3588 22.9701 11.3987 22.4876 9.42875C22.0087 7.47376 21.3267 5.4368 20.3456 3.86607C20.1713 3.58703 19.9831 3.31609 19.7803 3.05927C25.2719 4.45878 29.3332 9.43765 29.3332 15.3651Z"
                                fill="#83B25F"/>
                            <path
                                d="M14.9998 26.6667V16H10.4463C10.4743 15.7181 10.5083 15.4008 10.5492 15.0551C10.7166 13.6412 10.9983 11.768 11.4547 9.90458C11.9148 8.02624 12.5357 6.22987 13.3503 4.9256C14.1722 3.60987 15.0514 3 15.9998 3C16.9482 3 17.8275 3.60987 18.6493 4.9256C19.464 6.22987 20.0849 8.02624 20.545 9.90458C21.0014 11.768 21.2831 13.6412 21.4504 15.0551C21.4914 15.4008 21.5254 15.7181 21.5533 16H16.9998V26.6667C16.9998 28.6917 15.3582 30.3333 13.3332 30.3333C11.3081 30.3333 9.6665 28.6917 9.6665 26.6667V25.3333C9.6665 24.781 10.1142 24.3333 10.6665 24.3333C11.2188 24.3333 11.6665 24.781 11.6665 25.3333V26.6667C11.6665 27.5871 12.4127 28.3333 13.3332 28.3333C14.2536 28.3333 14.9998 27.5871 14.9998 26.6667Z"
                                fill="#83B25F"/>
                        </svg>


                    </div>

                    <div class="text" [innerHTML]="'calendar.holiday' | transloco" >

                    </div>

                </div>


                <div class="popup" *ngIf="day.absence">

                    <div class="svg">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0.75C6.41421 0.75 6.75 1.08579 6.75 1.5V2.26272C7.41203 2.24999 8.1414 2.24999 8.94358 2.25H13.0564C13.8586 2.24999 14.588 2.24999 15.25 2.26272V1.5C15.25 1.08579 15.5858 0.75 16 0.75C16.4142 0.75 16.75 1.08579 16.75 1.5V2.32709C17.0099 2.34691 17.2561 2.37182 17.489 2.40313C18.6614 2.56076 19.6104 2.89288 20.3588 3.64124C21.1071 4.38961 21.4392 5.33855 21.5969 6.51098C21.6472 6.88567 21.681 7.29459 21.7037 7.74007C21.7337 7.82106 21.75 7.90861 21.75 8C21.75 8.06932 21.7406 8.13644 21.723 8.20016C21.75 9.00214 21.75 9.91275 21.75 10.9436V13.0564C21.75 14.8942 21.75 16.3498 21.5969 17.489C21.4392 18.6614 21.1071 19.6104 20.3588 20.3588C19.6104 21.1071 18.6614 21.4392 17.489 21.5969C16.3498 21.75 14.8942 21.75 13.0564 21.75H8.94359C7.10583 21.75 5.65019 21.75 4.51098 21.5969C3.33856 21.4392 2.38961 21.1071 1.64124 20.3588C0.89288 19.6104 0.560763 18.6614 0.403135 17.489C0.249972 16.3498 0.249984 14.8942 0.25 13.0564V10.9436C0.249991 9.91275 0.249984 9.00214 0.277009 8.20017C0.259406 8.13645 0.250001 8.06932 0.250001 8C0.250001 7.90862 0.266345 7.82105 0.296269 7.74006C0.318954 7.29458 0.35276 6.88566 0.403135 6.51098C0.560763 5.33856 0.89288 4.38961 1.64124 3.64124C2.38961 2.89288 3.33856 2.56076 4.51098 2.40313C4.7439 2.37182 4.99006 2.34691 5.25 2.32709V1.5C5.25 1.08579 5.58579 0.75 6 0.75ZM1.76309 8.75C1.75032 9.40273 1.75 10.146 1.75 11V13C1.75 14.9068 1.75159 16.2615 1.88976 17.2892C2.02502 18.2952 2.27869 18.8749 2.7019 19.2981C3.12511 19.7213 3.70476 19.975 4.71085 20.1102C5.73851 20.2484 7.09318 20.25 9 20.25H13C14.9068 20.25 16.2615 20.2484 17.2892 20.1102C18.2952 19.975 18.8749 19.7213 19.2981 19.2981C19.7213 18.8749 19.975 18.2952 20.1102 17.2892C20.2484 16.2615 20.25 14.9068 20.25 13V11C20.25 10.146 20.2497 9.40273 20.2369 8.75H1.76309ZM20.1683 7.25H1.83168C1.8477 7.06061 1.86685 6.88123 1.88976 6.71085C2.02502 5.70476 2.27869 5.12511 2.7019 4.7019C3.12511 4.27869 3.70476 4.02502 4.71085 3.88976C5.73851 3.75159 7.09318 3.75 9 3.75H13C14.9068 3.75 16.2615 3.75159 17.2892 3.88976C18.2952 4.02502 18.8749 4.27869 19.2981 4.7019C19.7213 5.12511 19.975 5.70476 20.1102 6.71085C20.1331 6.88123 20.1523 7.06061 20.1683 7.25Z" fill="#EB5757"/>
                        </svg>

                    </div>

                    <div class="text">
                        {{ ('calendar.missed' | transloco ) }}
                    </div>

                </div>
            </td>
        </tr>
        </tbody>
    </table>

</div>
